import { Metrics } from 'I18n/utils/Metrics';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import Raven from 'raven-js';
const LIMIT_CARD_I18N_HEADING = {
  documents: 'limitUsageComponents.limits.documents.heading',
  templates: 'limitUsageComponents.limits.templates.heading',
  'object-lists-dynamic': 'limitUsageComponents.limits.object-lists-dynamic.heading',
  snippets: 'limitUsageComponents.limits.snippets.heading',
  dashboards: 'limitUsageComponents.limits.dashboards.heading',
  'cms-blog-posts': 'limitUsageComponents.limits.cms-blog-posts.heading',
  'pipeline-deals': 'limitUsageComponents.limits.pipeline-deals.heading',
  'pipeline-tickets': 'limitUsageComponents.limits.pipeline-tickets.heading',
  email_sends: 'limitUsageComponents.limits.email_sends.heading',
  'core-seats': 'limitUsageComponents.limits.core-seats.heading',
  'crm-products': 'limitUsageComponents.limits.crm-products.heading'
};
const LIMIT_CARD_I18N_DESCRIPTION = {
  documents: 'limitUsageComponents.limits.documents.description',
  templates: 'limitUsageComponents.limits.templates.description',
  'object-lists-dynamic': 'limitUsageComponents.limits.object-lists-dynamic.description',
  snippets: 'limitUsageComponents.limits.snippets.description',
  dashboards: 'limitUsageComponents.limits.dashboards.description',
  'cms-blog-posts': 'limitUsageComponents.limits.cms-blog-posts.description',
  'pipeline-deals': 'limitUsageComponents.limits.pipeline-deals.description',
  'pipeline-tickets': 'limitUsageComponents.limits.pipeline-tickets.description',
  email_sends: 'limitUsageComponents.limits.email_sends.description',
  'core-seats': 'limitUsageComponents.limits.core-seats.description',
  'crm-products': 'limitUsageComponents.limits.crm-products.description'
};
const LIMIT_CARD_I18N_UPGRADE = {
  documents: 'limitUsageComponents.limits.documents.upgrade',
  templates: 'limitUsageComponents.limits.templates.upgrade',
  'object-lists-dynamic': 'limitUsageComponents.limits.object-lists-dynamic.upgrade',
  snippets: 'limitUsageComponents.limits.snippets.upgrade',
  dashboards: 'limitUsageComponents.limits.dashboards.upgrade',
  'cms-blog-posts': 'limitUsageComponents.limits.cms-blog-posts.upgrade',
  'pipeline-deals': 'limitUsageComponents.limits.pipeline-deals.upgrade',
  'pipeline-tickets': 'limitUsageComponents.limits.pipeline-tickets.upgrade',
  email_sends: 'limitUsageComponents.limits.email_sends.upgrade',
  'core-seats': 'limitUsageComponents.limits.core-seats.upgrade',
  'crm-products': 'limitUsageComponents.limits.crm-products.upgrade'
};
export const getLimitCardTanslation = (limitName, translationType) => {
  const translationTypeMap = {
    heading: LIMIT_CARD_I18N_HEADING,
    description: LIMIT_CARD_I18N_DESCRIPTION,
    upgrade: LIMIT_CARD_I18N_UPGRADE
  };
  const translationKey = translationTypeMap[translationType][limitName];
  if (!isValidI18nKey(translationKey)) {
    Metrics.counter('limit-card-translation-error', {
      limit_name: limitName,
      translation_type: translationType
    }).increment();
    Raven.captureException(new Error(`Cannot find valid translation for limit card with name: '${limitName}' and translation type: ${translationType}`));
    return null;
  }
  return translationKey;
};